// all application settings
var Settings = {
    parseAppId: 'gt-coorporacionsantaana',
    parseKey: '',
    parseUrl: 'https://gt-coorporacionsantaana-1fa1cff6193f.herokuapp.com/parse',
    deepLinkUrl: '',
    privacityPoliticsURL: '',
    blockscreenshot: true,
    login: false,
    footer: {
        active: true,
        dacor: false,
        links: [
          {
            defaultText: "Política de cookies",
            url: "https://www1.shogunmonitor.com/privacy-policies/cookies-policy.html"
          },
          {
            defaultText: "Política de privacidad",
            url: "https://www1.shogunmonitor.com/privacy-policies/privacy-policy.html"
          },
        ]
    }

};

export const LanguageDefault = { "es" :
{
  "AcceptBtn":"Aceptar",
  "AccepttermsSubtittle":"Para Continuar debe aceptar nuestros Términos y Condiciones de Uso.",
  "AccepttermsSubtittle2":"Siga el siguiente link para conocer más:",
  "AttachBtn":"Adjuntar archivo, imagen o video",
  "Attachfilesreport":"Archivos adjuntos:",
  "BackBtn":"Regresar",
  "Btn_back":"Regresar",
  "Btn_home":"Inicio",
  "Btn_NewsBack":"Regresar",
  "CheckAttachedFile":"ver enlace adjunto",
  "Comment_send":"ENVIAR",
  "Conferencistas_conferencistas":"Conferencistas",
  "ConsultBtn":"Consultar",
  "CopyBtn":"Copiar",
  "CopiedBtn":"Copiado",
  "CreateCommentPlaceHolder":"Realice un comentario",
  "CreateCommentThks":"Gracias",
  "CreateCommentThksMessage":"Su comentario es valioso para mejorar nuestros procedimientos y nuestra comunidad",
  "CreateCommentTittle":"Comentar denuncia",
  "CreateReport":"Creando Denuncia",
  "DescPlaceHolder":"Realice su Denuncia",
  "Descriptionmsg":"Favor Ingrese la descripción",
  "Errorinfo": "Favor completar toda la información",
  "termscons": "Términos y Condiciones de Uso",
  "CheckboxText":"He leído y acepto los",
  "Filetolarge":"El archivo es muy grande para subir al sistema, favor subir un archivo menor a 80mb",
  "Home_Conferencistas":"Conferencistas",
  "Home_News":"Noticias",
  "Home_Patrocinadores":"Patrocinadores",
  "Home_Programa":"Programa",
  "InfoText":"Denuncie cualquier infracción de las políticas y valores éticos.",
  "InfoText2":"Utilice la herramienta del buscador para encontrar una categoría",
  "InfoText3":"Seleccione una categoría",
  "InsertDetailsReportTittle": "Realizar una denuncia sobre",
  "inputsearchcode":"Buscar...",
  "LocalizationModalTittle":"Seleccione un lenguaje",
  "MainTittle":"Línea de Transparencia",
  "MakeQuestionClapfo":"REALIZAR Denuncia",
  "Modal2btn":"Regresar",
  "MyReportsBtn":"Mis denuncias",
  "MyReportsModalInfo":"Estos son los códigos de preguntas que ha realizado, selecciones para consultar",
  "MyReportsModalTittle":"Mis Preguntas",
  "NewReportBtn":"Realizar denuncias",
  "NewReportForCat": "Crear denuncia <br> En esta sección puedes presentar sus reclamos sobre los conceptos abajo indicados.",
  "News_news":"Noticias",
  "NoReportFound":"No se encontro ningun reporte, verifique el código consultado",
  "OptionalText":"* Nombre opcional",
  "Placeholder-home":"Ingrese código del reporte",
  "PushNews": "Nueva Noticia",
  "PushRepTitle": "Nuevo ",
  "PushSeeMore": "Ver Más",
  "PushSeeReport": "Ver reporte",
  "ReportActivity":"Te garantizamos la confidencialidad <br> de tu denuncia",
  "ReportCommentAdmin":"ADMINISTRADORES",
  "ReportCommentAnonymous":"Usuario Anónimo",
  "ReportCommentsTittle":"Comentarios",
  "ReportDays1":"Creado hace",
  "ReportDays2":"días",
  "ReportDescription":"Seleccione una actividad y realicé una denuncia",
  "ReportDetailSubTittle":"Descripción del reporte o denuncia",
  "ReportDetailTittle":"Consulta denuncia",
  "ReportNewComment":"Crear comentario",
  "ReportStatus1":"En proceso...",
  "ReportStatus2":"Cerrado",
  "ReportStatus3":"Descartado",
  "search":"Buscar categoría",
  "SelectCategory":"Seleccione un tipo de denuncia",
  "Selectprogram":"Ayuda a mejorar tu empresa notificando sobre problemas que hay en esta",
  "Selectprogram2": "Ayuda a mejorar tu empresa notificando sobre problemas que hay en esta",
  "SendBtn":"Enviar",
  "Singlenews_singlenews":"Noticia",
  "SubsidiaryBtn":"Entra a la filial electrónica",
  "Termnstittle":"Términos y Condiciones de uso",
  "ThksInfo":"Se ha generado un nuevo caso. Para seguirlo sería por medio del siguiente código:",
  "ThksTittle":"Gracias por su reporte o denuncia",
  "UserNameReportHolder":"Nombre (opcional)",
  "WarningTittle":"Aviso",
  "btnshowcustomformdetailsmodal":"Ver detalles",
  "InsertDetailsReportSubtitle":"Categoria: ",
  "needcode":"A fin de consultar un reporte, por favor, ingrese un código *",
  "needacceptterms":"Para continuar tiene que aceptar nuestros términos y condiciones de uso * ",
  "needfield":"Este campo es obligatorio *",
  "Webtitle":"Santa Ana Línea de Denuncias",
  "NotifReportAnonymous":"Recibirás notificaciones de tu reporte, garantizando siempre tu anonimato",
  "needcomment":"Por favor, ingresar su comentario *",
  "CreationDateReportDetails":"Fecha de creación:",
  "Btn_linkinsponsors":"Visite nuestro campus virtual",
  "footerBtn3":"Aviso Legal",
 "footerBtn1":"Política de Cookies",
 "footerBtn2":"Política de Privacidad",
  "footerRights":"Todos los derechos reservados ©2023",
  "code-title":"¿Quieres consultar el estado de una denuncia enviada?",
  "masktitle":"Estado de la denuncia"
},
"it": {
  "AcceptBtn":"Accetta",
  "AccepttermsSubtittle":"Per continuare devi accettare i nostri Termini e Condizioni d'Uso.",
  "AccepttermsSubtittle2":"Segui il seguente link per saperne di più:",
  "AttachBtn":"Allega file, immagine o video",
  "Attachfilesreport":"File allegati:",
  "BackBtn":"Indietro",
  "Btn_back":"Indietro",
  "Btn_home":"Home",
  "Btn_NewsBack":"Indietro",
  "CheckAttachedFile":"vedi file allegato",
  "Comment_send":"INVIA",
  "Conferencistas_conferencistas":"Relatori",
  "ConsultBtn":"Consulta",
  "CopyBtn":"Copia",
  "CopiedBtn":"Copiato",
  "CreateCommentPlaceHolder":"Inserisci un commento",
  "CreateCommentThks":"Grazie",
  "CreateCommentThksMessage":"Il tuo commento è prezioso per migliorare i nostri procedimenti e la nostra comunità",
  "CreateCommentTittle":"Commenta segnalazione",
  "CreateReport":"Creazione Segnalazione",
  "DescPlaceHolder":"Inserisci la tua Segnalazione",
  "Descriptionmsg":"Per favore, inserisci la descrizione",
  "Errorinfo": "Si prega di compilare tutte le informazioni",
  "termscons": "Termini e Condizioni d'Uso",
  "CheckboxText":"Ho letto e accetto i",
  "Filetolarge":"Il file è troppo grande per essere caricato nel sistema, si prega di caricare un file inferiore a 80mb",
  "Home_Conferencistas":"Relatori",
  "Home_News":"Notizie",
  "Home_Patrocinadores":"Sponsor",
  "Home_Programa":"Programma",
  "InfoText":"Segnala qualsiasi violazione delle politiche e dei valori etici, aiutaci a migliorare la tua opinione se conta",
  "InfoText2":"Utilizza lo strumento di ricerca per trovare una categoria",
  "InfoText3":"Seleziona una categoria",
  "InsertDetailsReportTittle": "Fare una segnalazione su",
  "inputsearchcode":"Cerca...",
  "LocalizationModalTittle":"Seleziona una lingua",
  "MainTittle":"Linea di Denuncia",
  "MakeQuestionClapfo":"Fare Segnalazione",
  "Modal2btn":"Indietro",
  "MyReportsBtn":"Le mie segnalazioni",
  "MyReportsModalInfo":"Questi sono i codici delle domande che hai fatto, seleziona per consultare",
  "MyReportsModalTittle":"Le mie Domande",
  "NewReportBtn":"Fare Segnalazioni",
  "NewReportForCat": "Crea segnalazione <br> In questa sezione puoi presentare i tuoi reclami sui concetti indicati di seguito.",
  "News_news":"Notizie",
  "NoReportFound":"Nessuna segnalazione trovata, controlla il codice consultato",
  "OptionalText":"* Nome opzionale",
  "Placeholder-home":"Inserisci il codice della segnalazione",
  "PushNews": "Nuova Notizia",
  "PushRepTitle": "Nuovo ",
  "PushSeeMore": "Vedi di più",
  "PushSeeReport": "Vedi segnalazione",
  "ReportActivity":"Garantiamo l'anonimato <br> della tua segnalazione",
  "ReportCommentAdmin":"AMMINISTRATORI",
  "ReportCommentAnonymous":"Utente Anonimo",
  "ReportCommentsTittle":"Commenti",
  "ReportDays1":"Creato da",
  "ReportDays2":"giorni",
  "ReportDescription":"Seleziona un'attività e fai una segnalazione",
  "ReportDetailSubTittle":"Descrizione della segnalazione o denuncia",
  "ReportDetailTittle":"Consulta segnalazione",
  "ReportNewComment":"Crea commento",
  "ReportStatus1":"In corso...",
  "ReportStatus2":"Chiuso",
  "ReportStatus3":"Scartato",
  "search":"Cerca categoria",
  "SelectCategory":"Seleziona un tipo di segnalazione",
  "Selectprogram":"Aiuta a migliorare la tua azienda segnalando i problemi presenti in essa",
  "Selectprogram2": "Aiuta a migliorare la tua azienda segnalando i problemi presenti in essa",
  "SendBtn":"Invia",
  "Singlenews_singlenews":"Notizia",
  "SubsidiaryBtn":"Entra nella filiale elettronica",
  "Termnstittle":"Termini e Condizioni d'uso",
  "ThksInfo":"È stato generato un nuovo caso. Per continuare a seguirlo, sarebbe tramite il seguente codice:",
  "ThksTittle":"Grazie per la tua segnalazione o denuncia",
  "UserNameReportHolder":"Nome (opzionale)",
  "WarningTittle":"Avviso",
  "btnshowcustomformdetailsmodal":"Mostra dettagli",
  "InsertDetailsReportSubtitle":"Categoria: ",
  "needcode":"Per consultare la tua segnalazione, per favore, inserisci un codice *",
  "needacceptterms":"Per continuare devi accettare i nostri Termini e Condizioni d'Uso * ",
  "needfield":"Questo campo è obbligatorio *",
  "Webtitle":"Santa Ana Linea di Segnalazione",
  "NotifReportAnonymous":"Riceverai notifiche della tua segnalazione, garantendo sempre il tuo anonimato",
  "needcomment":"Per favore, inserisci il tuo commento *",
  "CreationDateReportDetails":"Data di creazione:",
  "Btn_linkinsponsors":"Visita il nostro campus virtuale",
  "footerBtn3":"Avviso Legale",
  "footerBtn1":"Politica dei Cookie",
  "footerBtn2":"Informativa sulla Privacy",
  "footerRights":"Tutti i diritti riservati ©2023",
  "code-title":"Vuoi controllare lo stato della tua segnalazione?",
  "masktitle":"Stato della segnalazione"
}
}

export default Settings;
